import React, { useContext, useEffect, useState, useMemo } from 'react'
import { makeStyles } from '@material-ui/core'
import { cloneDeep, isNull } from 'lodash'
import MarblesChart from '../components/MarblesChart'
import MarblesLegend from '../components/MarblesLegend'
import SummaryStatsBox from '../components/SummaryStatsBox'
import generateRiskCounts from '../ultils/generateRiskCounts'
import { Context as PortfolioContext } from '../contexts/portfolio'
import { RISK_TYPE } from '../ultils/chart-d3-utils'
import CompanySidebarList from '../components/CompanySidebarList/CompanySidebarList'

const useStyles = makeStyles({
  chartContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-start',
    backgroundColor: '#fff',
    borderRadius: 5,
    overflowX: 'hidden',
    width: '100%',
    flexWrap: 'nowrap',
  },
  legendWrapper: {
    flexBasis: '15%',
    flexShrink: 0,
    height: 500,
    position: 'relative',
    minWidth: 0,
    overflow: 'visible',
  },
  visArea: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 0,
  },
  indexBoard: {
    flexBasis: '16%',
    flexShrink: 0,
    minWidth: 0,
    marginRight: 10,
  },
  sidebar: {
    flexBasis: '30%',
    flexShrink: 0,
    maxWidth: '30%',
    // overflow: 'hidden',
    margin: '0 10px 10px 0',
    maxHeight: '500px',
    height: '500px',
  },
  indexBoardChild: {
    paddingTop: 30,
  },
  chartInnerWrapper: {
    width: '100%',
    maxWidth: '100%',
    minWidth: '300px',
    height: 500,
  },
})

const iniFilter = {
  sector : [],
  industry : [],
  region : [],
  country : [],
}
const PortfolioTodayCompanyPage = ({ tickers, riskType, tickerId }) => {
  const classes = useStyles()

  const { state, setActiveNode } = useContext(PortfolioContext)
  const [selectedFilter, setSelectedFilter] = useState(iniFilter)

  const baseFiltered = useMemo(() => {
    if (
        isNull(state.activeNode) ||
        state.activeNode.name === 'total' ||
        !state.activeNode.name
    )
      return cloneDeep(tickers)

    return cloneDeep(tickers).filter(t =>
        riskType === RISK_TYPE.CREDIT
            ? t.credit_status === state.activeNode.name
            : t.risk_outlook === state.activeNode.name,
    )
  }, [state.activeNode, tickers, riskType])

  const tickerData = useMemo(() => {
    let tmp = baseFiltered;
    if (selectedFilter?.sector && selectedFilter?.sector.length > 0) {
      tmp = tmp.filter(t => selectedFilter?.sector.includes(t.factset_sector_desc));
    }
    if (selectedFilter?.industry && selectedFilter?.industry.length > 0) {
      tmp = tmp.filter(t => selectedFilter?.industry.includes(t.industry));
    }
    if (selectedFilter?.region && selectedFilter?.region.length > 0) {
      tmp = tmp.filter(t => selectedFilter?.region.includes(t.region));
    }
    if (selectedFilter?.country && selectedFilter?.country.length > 0) {
      tmp = tmp.filter(t => selectedFilter?.country.includes(t.iso_country));
    }
    return tmp;
  }, [baseFiltered, selectedFilter]);

  const riskCountData = generateRiskCounts(tickers, riskType)

  const setMarblesData = d => {
    setActiveNode(d)
  }

  const resetAllFilters = React.useCallback(() => {
    setSelectedFilter(iniFilter)
    setActiveNode(null)
  }, [])

  useEffect(() => {
    setSelectedFilter(iniFilter)
  }, [state.activeNode])

  return (
    <div className={classes.chartContainer}>
      <div className={classes.legendWrapper}>
        <MarblesLegend
          data={riskCountData}
          setMarblesData={setMarblesData}
          activeNode={state.activeNode}
          isCompanyPage={true}
        />
      </div>
      <div className={classes.visArea}>
        <div className={classes.chartInnerWrapper}>
          <MarblesChart
            isEmptyData={state.tickersInPortfolio.length === 0}
            tickers={tickerData}
            riskType={riskType}
            group="none"
          />
        </div>
      </div>
      <div className={classes.indexBoard}>
        <div className={classes.indexBoardChild}>
          <SummaryStatsBox
            riskType={riskType}
            total={tickers.length}
            setMarblesData={setMarblesData}
            data={riskCountData}
            segmentClicked={state.activeNode}
            setSegmentClicked={setActiveNode}
          />
        </div>
      </div>
      <div className={classes.sidebar}>
         <CompanySidebarList
             data={tickerData}
             selectedFilter={selectedFilter}
             setSelectedFilter={setSelectedFilter}
             onResetAll={resetAllFilters}
             tickerId={tickerId}
             activeNode={state.activeNode}
         />
        </div>
      </div>
  )
}

export default PortfolioTodayCompanyPage
